export const isDiff = (wsMessage) => {
    if (wsMessage.diff === undefined || wsMessage.diff === true) {
        return true;
    }
    else {
        return false;
    }
};



// WEBPACK FOOTER //
// ./src/web-frontend-core/helpers/isDiffDefinder/isDiff.js